// Custom fields
type CustomFieldTypes = `string` | `number` | `multiselect` | `select` | `boolean`;

// Stop fields ===============================================================
export const projectDriversStopFieldsID = [
  `external_id`,
  `comments`,
  `location_details`,
  `phone`,
  `email`,
  `reference_person`,
  `planned_arrival_time`,
  `estimated_arrival_time`,
  `weight`,
  `volume`,
  `time_windows`,
  `requires`,
  `url`,
];

export const projectDriversStopFieldsValues = {
  external_id: `string`,
  comments: `string`,
  location_details: `string`,
  phone: `phone`,
  email: `email`,
  reference_person: `string`,
  planned_arrival_time: `time`,
  estimated_arrival_time: `time`,
  weight: `number`,
  volume: `number`,
  time_windows: `time_windows`,
  requires: `list`,
  url: `string`,
};

export type ProjectDriversStopFieldsType =
  | `string`
  | `number`
  | `time`
  | `time_window`
  | `email`
  | `phone`
  | `list`
  | CustomFieldTypes;

// Task fields ===============================================================
export const projectDriversTaskFieldsValues = {
  barcode: `barcode`,
  comments: `string`,
};

export type ProjectDriversTaskType = `string` | `barcode` | CustomFieldTypes;

// Report tasks ===============================================================
export const projectDriversTaskCancelValues = {
  comments: `string`,
};

export type ProjectDriversTaskCancelType = `string` | CustomFieldTypes;

export const projectDriversTaskCompleteValues = {
  comments: `string`,
};

export type ProjectDriversTaskCompleteType = `string` | CustomFieldTypes;

// Report fields ===============================================================
export const projectDriversReportCancelValues = {
  cancel_reason: `select`,
  images: `images`,
  comments: `string`,
};

export type ProjectDriversReportCancelType = `string` | `images` | CustomFieldTypes;

export const projectDriversReportCompleteValues = {
  signature: `signature`,
  images: `images`,
  comments: `string`,
};

export type ProjectDriversReportCompleteType = `signature` | `string` | `images` | CustomFieldTypes;
